export const addCommas = (num) => {
  const browserLanguage = navigator.language || "default";
  return new Intl.NumberFormat(browserLanguage).format(num);
};
